import { createMasterScreen } from '../../../components/erp/ERPMasterScreenFactory';
export default createMasterScreen({
  title: 'Design Master', screenId: '4.3.9', module: 'Procurement', apiPath: 'design', screenName: 'DesignMaster', idField: 'DesId', nameField: 'DesName',
  gridColumns: [{ field: 'DesId', header: 'Design ID' }, { field: 'DesName', header: 'Design Name' }],
  formFields: [{ field: 'DesId', label: 'Design Id', disabled: true }, { field: 'DesName', label: 'Design Name', required: true }]
});
